import { render, staticRenderFns } from "./Identification.vue?vue&type=template&id=251867dc&scoped=true"
import script from "./Identification.vue?vue&type=script&lang=js"
export * from "./Identification.vue?vue&type=script&lang=js"
import style0 from "./Identification.vue?vue&type=style&index=0&id=251867dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251867dc",
  null
  
)

export default component.exports